<template>
  <div class="modal modal__filter-search-form is-active">
    <div class="modal-background"></div>
    <div class="modal-card filter-form">
      <header class="modal-card-head is-radiusless">
        <div class="modal-card-title is-flex justify-content-between align-items-center">
          <a class="clear text-secondary hover-opacity-8 hover-text-secondary" @click="clearFilter()">Clear</a>
          <span class="has-text-black">Filter</span>
          <button
            @click="closeFilter()"
            class="button bg-secondary text-white hover-opacity-7 filter-close-btn"
          >Close</button>
        </div>

        
      </header>
      <section class="modal-card-body">
        <!-- control: distance -->
        <!-- <section class="control-section--filter has-border-top filter--distance-range">
          <header class="is-flex justify-content-between">
            <label class="control-name">Distance</label>
            <span class="control-value">{{filter.distance}} km</span>
          </header>
          <input
            type="range"
            class="range is-link"
            name="points"
            min="0"
            max="50"
            v-model="filter.distance"
          />
        </section> -->

        <!-- control: product-type -->
        <section class="control-section--filter product-form">
   
          <label class="control-name">Type</label>
          <div class="filter-radio-group mt15">

            <div class="control variant-block has-text-centered">
              <input
                v-model="filter.plant_type"
                class="is-checkradio is-block"
                id="product-type-two"
                type="checkbox"
                name="product-type"
                value="indica"
              />
              <label for="product-type-two" class="label-wrap">
                 <div class="variant-item-block justify-content-center is-flex align-items-center height-full">
                  <!-- <div>
                    <img :src="plant_type['indica']" alt="indica"/>
                  </div> -->
                  <div>Indica</div>
                </div>
              </label>
            </div>

            <div class="control variant-block has-text-centered">
              <input
                v-model="filter.plant_type"
                class="is-checkradio is-block"
                id="product-type-one"
                type="checkbox"
                name="product-type"
                value="sativa"              
              />
              <label for="product-type-one" class="label-wrap">
                <div class="variant-item-block justify-content-center is-flex align-items-center height-full">
                  <!-- <div>
                    <img :src="plant_type['sativa']" alt="sativa"/>
                  </div> -->
                  <div>Sativa</div>
                </div>
              </label>
            </div>

            <div class="control variant-block has-text-centered">
              <input
                v-model="filter.plant_type"
                class="is-checkradio is-block"
                id="product-type-three"
                type="checkbox"
                name="product-type"
                value="hybrid"
              />
              <label for="product-type-three" class="label-wrap">
                 <div class="variant-item-block justify-content-center is-flex align-items-center height-full">
                  <!-- <div>
                    <img :src="plant_type['hybrid']" alt="hybrid" />
                  </div> -->
                  <div>Hybrid</div>
                </div>
              </label>
            </div>
          </div>
        </section>

        <!-- control: THC Content -->
        <section class="control-section--filter product-form">
          <label class="control-name has-text-black">Intensity</label>
          <div class="filter-radio-group mt15">
            <div class="control variant-block has-text-centered">
              <input
                class="is-checkradio is-block"
                id="thc-content-low"
                type="checkbox"
                name="thc-content"
                value="low"
                v-model="filter.thc"
              />
              <label for="thc-content-low" class="label-wrap">
                 <div class="variant-item-block justify-content-center is-flex align-items-center height-full">
                  <div>THC <br/> Low</div>
                </div>
              </label>
            </div>

            <div class="control variant-block has-text-centered">
              <input
                class="is-checkradio is-block"
                id="thc-content-medium"
                type="checkbox"
                name="thc-content"
                value="medium"
                v-model="filter.thc"
              />
              <label for="thc-content-medium" class="label-wrap">
                <div class="variant-item-block justify-content-center is-flex align-items-center height-full">
                  <div>THC <br/> Medium</div>
                </div>
              </label>
            </div>

            <div class="control variant-block has-text-centered">
              <input
                class="is-checkradio is-block"
                id="thc-content-high"
                type="checkbox"
                name="thc-content"
                value="high"
                v-model="filter.thc"
              />
              <label for="thc-content-high" class="label-wrap">
                 <div class="variant-item-block justify-content-center is-flex align-items-center height-full">
                  <div>THC <br/> High</div>
                </div>
              </label>
            </div>

            <!-- cbd -->
            <div class="control variant-block has-text-centered">
              <input
                class="is-checkradio is-block"
                id="cbd-content-low"
                type="checkbox"
                name="cbd-content"
                value="low"
                v-model="filter.cbd"
              />
              <label for="cbd-content-low" class="label-wrap">
                 <div class="variant-item-block justify-content-center is-flex align-items-center height-full">
                  <div>CBD <br/> Low</div>
                </div>
              </label>
            </div>

            <div class="control variant-block has-text-centered">
              <input
                class="is-checkradio is-block"
                id="cbd-content-medium"
                type="checkbox"
                name="cbd-content"
                value="medium"
                v-model="filter.cbd"
              />
              <label for="cbd-content-medium" class="label-wrap">
                 <div class="variant-item-block justify-content-center is-flex align-items-center height-full">
                  <div>CBD <br/> Medium</div>
                </div>
              </label>
            </div>

            <div class="control variant-block has-text-centered">
              <input
                class="is-checkradio is-block"
                id="cbd-content-high"
                type="checkbox"
                name="cbd-content"
                value="high"
                v-model="filter.cbd" 
              />
              <label for="cbd-content-high" class="label-wrap">
                 <div class="variant-item-block justify-content-center is-flex align-items-center height-full">
                  <div>CBD <br/> High</div>
                </div>
              </label>
            </div>
            <!-- cbd ends -->

          </div>
        </section>

        <!-- control: Brands Content -->
        <section class="control-section--filter search-brands">
           <label class="control-name">Brands</label> 
          <div class="filter-radio-group mt15">
            <div class="control variant-block-new-style" v-bind:key="'filter_brand_'+brand.id" v-for="brand in brandList">
                <input
                  class="is-checkradio is-block"
                  :id="brand.id +'_brand_item_search'"
                  type="checkbox"
                  name="brand"
                  :value="brand.name"
                  v-model="filter.brands"
                />
                <label :for="brand.id +'_brand_item_search'" class="label-wrap">
                  <div class="variant-item-block">
                    <div class="variant-price">{{ brand.name }}</div>
                  </div>
                </label>
              </div>
          </div>
        </section> 
      </section>

      <footer class="modal-card-foot is-paddingless">
        <button
          @click="closeFilter()"
          class="button is-large bg-secondary text-white hover-opacity-7 is-full-width is-radiusless"
        >See Results ({{results}})</button>
      </footer>
    </div>
  </div>
</template>

<script>
import Env from "@/env";
import { mapGetters, mapActions } from "vuex";
import BrandApis from '@/Components/Controllers/BrandApis';

export default {
  props: ["results"],

  data() {
    return {
      brandList: [],

      filter: {
        search: '',
        plant_type: [],
        product_form: [],
        thc: [],
        cbd: [],
        sort: 'default',
        brands: [],
        size: [],
        from_categories: [],
        parent_category: null,
        
      }
    };
  },

  async mounted() {
    
    let res = await BrandApis.fetchBrands(this.vg_selectedStore.id);
    this.brandList = (res.status == 200) ? res.data.payload : [];
    
    // get default value from vuex, 
    this.filter.plant_type = this.vg_searchFilter.plant_type;
    this.filter.product_form = this.vg_searchFilter.product_form;
    this.filter.thc = this.vg_searchFilter.thc;
    this.filter.cbd = this.vg_searchFilter.cbd;
    this.filter.brands = this.vg_searchFilter.brands;

   
  },

  computed: {
    ...mapGetters({
      vg_searchFilter: "searchproduct/searchFilter",
      va_doSearch: "searchproduct/doSearch",
      vg_selectedStore: "location/selected",
    }),
    plant_type() {
      return Env.product_type;
    },
  },
  watch: {
    filter: {
      handler: function () {
        this.saveFilter();
      },
      deep: true
    }
  },
  methods: {
    /**
     * Close filter right sidebar
     */
    closeFilter() {
      bus.$emit('close-filter', false);
    },
    /**
     * Save filter params
     */
    saveFilter() {
      this.va_setSearchFilter(this.filter);
      this.va_setDoSearch(!this.va_doSearch);
    },
    /**
     * Clear filters
     */
    clearFilter() {
      this.filter = {
        distance: 0,
        plant_type: [],
        product_form: [],
        thc: [],
        cbd: [],
        brands: [],
      };

      this.va_setSearchFilter(this.filter);
      // reset search filter
      this.va_setDoSearch(!this.va_doSearch);
    },
    ...mapActions({
      va_setSearchFilter: "searchproduct/setSearchFilter",
      va_setEmptySearchFilter: "searchproduct/setEmptySearchFilter",
      va_setDoSearch: "searchproduct/setDoSearch"
    })
  }
};
</script>
<style scoped>
.is-checkradio[type="checkbox"].no-bgcolor:hover,
.is-checkradio[type="checkbox"].no-bgcolor + label{
    background: #ffffff !important;
}
.modal__filter-search-form .control-section--filter.product-types .variant-block{
  width: 110px;
}
.modal-background{
  bottom: 0;
  top: 0;
}

.modal__filter-search-form .modal-card.filter-form {
  max-height: 100vh;
  min-height: 100vh;
}
</style>